<template>
  <div class="mapping-sort-header">
    <span
      class="mapping-sort-header__label"
      role="button"
      tabindex="0"
      :title="sortTitle"
      @click.stop="onToggle"
      @keydown.enter.prevent="onToggle"
      @keydown.space.prevent="onToggle"
    >
      <slot />
    </span>
    <i
      :class="['fas', 'mapping-sort-glyph', iconClass]"
      role="button"
      tabindex="0"
      :title="sortTitle"
      aria-hidden="true"
      @click.stop="onToggle"
      @keydown.enter.prevent="onToggle"
      @keydown.space.prevent="onToggle"
    />
    <span
      v-if="orderIndex != null"
      class="mapping-sort-order"
      :title="'Sort priority ' + orderIndex"
    >{{ orderIndex }}</span>
  </div>
</template>

<script>
import {
  mappingSortIconClass,
  mappingSortOrderIndex,
} from "@/common/mappingTableSort";

export default {
  name: "MappingSortableHeader",
  props: {
    field: { type: String, required: true },
    sortState: { type: Array, default: () => [] },
  },
  computed: {
    iconClass() {
      return mappingSortIconClass(this.sortState, this.field);
    },
    orderIndex() {
      return mappingSortOrderIndex(this.sortState, this.field);
    },
    sortTitle() {
      const item = (this.sortState || []).find(
        (s) => s && s.field === this.field,
      );
      if (!item) return "Sort ascending (click again for descending)";
      if (item.direction === "asc") {
        return "Sort descending (click again to clear)";
      }
      return "Clear sort";
    },
  },
  methods: {
    onToggle() {
      this.$emit("sort-toggle", this.field);
    },
  },
};
</script>
